<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="supplierInfoes"
        @select="selectOne"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editSupplierManage.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="名称">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="外部编号">
            <el-input v-model.trim="filter.outerNO" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" width="55"/>
      <el-table-column prop="no" label="编号"/>
      <el-table-column prop="name" width="200" show-overflow-tooltip label="名称"/>
      <el-table-column prop="outerNO" label="外部编号">
        <template slot-scope="scope">
          <span
              style="cursor: pointer; color:#2d8cf0"
              @click="$refs.editSupplierManage.open(scope.row.pkid,false)">{{scope.row.outerNO}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" width="100" show-overflow-tooltip label="简称"/>
      <el-table-column prop="shortCode" label="缩写"/>
      <el-table-column prop="contact" label="联系人"/>
      <el-table-column prop="mobile" label="手机号"/>
      <el-table-column prop="deliveryType" label="送货类型">
        <template slot-scope="scope">
          <span>{{deliveryTypes[scope.row.deliveryType]}}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="deliveryLeadtime" label="送货提前期(天)"/>-->
      <el-table-column prop="address" width="200" show-overflow-tooltip label="地址"/>
      <el-table-column prop="email" label="电子邮箱"/>
      <el-table-column prop="note" label="备注"/>
      <el-table-column
          v-if="editAuth"
          fixed="right"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="200px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.SupplierManageMaterial.open(scope.row)">物料预览</el-button>
          <el-button type="primary" @click="$refs.editSupplierManage.open(scope.row.pkid,true)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <supplier-manage-material ref="SupplierManageMaterial" @save-success="getList(1)"/>
    <supplier-manage-edit ref="editSupplierManage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import SupplierManageEdit from "@/views/information/SupplierManage/SupplierManageEdit";
  import SupplierManageMaterial from "@/views/information/SupplierManage/SupplierManageMaterial";

  export default {
    name: "SupplierManageList",
    components: {SupplierManageMaterial, SupplierManageEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        constant,
        deliveryTypes: constant.deliveryType,
        editAuth: this.$auth(161),
        filter: {
          no: "",
          name: "",
          outerNO: "",
          shortName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectOne(selection) {
        this.idList = selection;
        console.log(selection);
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if (this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic", "supplierInfoes/idList", ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        } else {
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "supplierInfoes", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
